import { createSelector } from 'reselect'
import { entitySelector } from 'containers/Entity/selectors'
import {
  approverImageStateSelector,
} from 'containers/Approval/ApproverSection/selectors'

const commentsStateSelector = state => state.approvals.comments

const commentSelectorFunc = (entities, commentRefs, imageRefs) => {
  return commentRefs.map(id => {
    const { username, ...comment } = entities['workflow_comments'][id]
    const { image } = imageRefs.includes(username)
      ? entities['user_photos'][username]
      : {}
    return { ...comment, username, image }
  })
}

const commentsSelector = createSelector(
  entitySelector,
  commentsStateSelector,
  approverImageStateSelector,
  commentSelectorFunc
)

const commentsUsernameSelector = createSelector(
  entitySelector,
  commentsStateSelector,
  (entities, commentRefs) => {
    const usernames = commentRefs.map(id => {
      const { username } = entities['workflow_comments'][id]
      return username
    })
    return [...new Set(usernames)]
  }
)

export {
  commentsSelector,
  commentsUsernameSelector
}
